/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Record_string_unknown_ } from './Record_string_unknown_';
/**
 * Tasks are used to defer function execution to a GCP Cloud Job runner. Stores
 * information such as who created the Task, when it was created, the status,
 * and information needed to run the execution at a later time.
 *
 * BackgroundTaskAttributes are entries in the `background_tasks` view. Nearly
 * all queries for tasks should be done to the `background_tasks` view. See
 * the `Task` type below for more information.
 */
export type BackgroundTaskAttributes = {
    /**
     * The unique ID of the task.
     */
    id: number;
    /**
     * User ID of who requested the Task.
     */
    user_id: string;
    /**
     * Name of the operation to execute.
     */
    name: string;
    /**
     * Information about the task's creation.
     */
    context: string | null;
    /**
     * A JSON object of the result. This should be client safe (i.e. not contain
     * sensitive information).
     */
    result: Record_string_unknown_ | null;
    /**
     * A JSON object of errors that have occurred during execution. If `status`
     * is 'failure', this JSONB column is not null.
     */
    error: Record_string_unknown_ | null;
    /**
     * A computed column with a string representation of the current status.
     */
    status: BackgroundTaskAttributes.status;
    /**
     * Timestamp when the task was created.
     */
    created_on: string;
    /**
     * Timestamp when the Task execution has started.
     */
    started_on: string | null;
    /**
     * Timestamp when the Task execution has finished.
     */
    finished_on: string | null;
    /**
     * Timestamp when user read the task results.
     */
    finished_read_on: string | null;
};
export namespace BackgroundTaskAttributes {
    /**
     * A computed column with a string representation of the current status.
     */
    export enum status {
        QUEUED = 'queued',
        PENDING = 'pending',
        COMPLETE = 'complete',
        FAILURE = 'failure',
    }
}

